export default "__VITE_ASSET__1d462ea5__"